import ActionTypes from "../constants/action_types";

export default function clearIssue(organisationId, issueId) {
  return {
    type: ActionTypes.ISSUE_CLEAR.SUCCESS,
    organisation_id: organisationId,
    issue_id: issueId,
  };
}
